import type {IssueAgentTask} from '../contexts/IssueAgentTasksContext'
import {getTaskTitle} from '@github-ui/agent-sessions/utils/task-helpers'
import {ActionList, ActionMenu, Truncate} from '@primer/react'
import {useCallback} from 'react'
import {Breadcrumbs} from '@github-ui/pacer/Breadcrumbs'
import styles from './TaskSwitcher.module.css'

type TaskSwitcherProps = {
  tasks: IssueAgentTask[]
  selectedTask: IssueAgentTask
  onSelectTask: (task: IssueAgentTask) => void
}

export function TaskSwitcher({tasks, selectedTask, onSelectTask}: TaskSwitcherProps) {
  const selectedTitle = getTaskTitle(selectedTask)

  const handleSelect = useCallback(
    (task: IssueAgentTask) => {
      if (task.id !== selectedTask.id) {
        onSelectTask(task)
      }
    },
    [selectedTask.id, onSelectTask],
  )

  return tasks.length <= 1 ? (
    <span className={styles.singleItem}>
      <Truncate inline maxWidth={320} title={selectedTitle}>
        {selectedTitle}
      </Truncate>
    </span>
  ) : (
    <div className={styles.multipleItems}>
      <Breadcrumbs aria-label="Agent sessions">
        <Breadcrumbs.ItemWithMenu
          menuOverlay={
            <ActionMenu.Overlay width="medium">
              <ActionList selectionVariant="single">
                <ActionList.Group>
                  <ActionList.GroupHeading>Agent sessions</ActionList.GroupHeading>
                  {tasks.map(task => (
                    <ActionList.Item
                      key={task.id}
                      selected={task.id === selectedTask.id}
                      onSelect={() => handleSelect(task)}
                    >
                      {getTaskTitle(task)}
                    </ActionList.Item>
                  ))}
                </ActionList.Group>
              </ActionList>
            </ActionMenu.Overlay>
          }
        >
          {selectedTitle}
        </Breadcrumbs.ItemWithMenu>
      </Breadcrumbs>
    </div>
  )
}
